import React from "react";
import { motion } from "framer-motion";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";

/** Masked line-by-line headline reveal. Content stays in DOM for SEO. */
export default function TextReveal({ lines, className = "", lineClassName = "", delay = 0 }) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return (
      <div className={className}>
        {lines.map((line) => (
          <span key={line} className={`block ${lineClassName}`}>
            {line}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={line} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.85,
              delay: delay + i * 0.12,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}
